import { HugeiconsIcon } from '@hugeicons/react'
import { ArrowLeft01Icon } from '@hugeicons/core-free-icons'

import { useAppStore } from '@/store'

// The apartment popup's DOM belongs to the viewer, not to React state.
//
// viewer.ts opens it by toggling .active on #apartment-popup-modal and then
// writes the title, description and media directly, and renders its own WebGL
// canvas into #apartment-popup-canvas. That contract predates the React port —
// the old index.html carried this markup statically — and porting it to
// React state would mean routing a 60fps render loop through the store for
// nothing. So React renders the shell once, with the ids the viewer expects,
// and never re-renders it: there is deliberately no state read below except
// the close action.
//
// This component existing at all is the fix for the popup silently not
// opening: the port dropped the old markup, so every getElementById inside
// openApartmentPopup() returned null.
export function ApartmentPopup() {
  const close = () => useAppStore.getState().viewer?.closeApartment()

  return (
    <div id="apartment-popup-modal" className="fixed inset-0 z-110">
      {/* Backdrop: clicking it leaves the apartment, same as the old UI. */}
      <div className="absolute inset-0 bg-black/70 backdrop-blur-sm" onClick={close} />

      <div className="absolute inset-4 flex flex-col overflow-hidden rounded-2xl bg-background sm:inset-8">
        <header className="pointer-events-auto absolute top-0 right-0 left-0 z-10 flex items-start justify-between p-4 sm:p-5">
          <button
            type="button"
            onClick={close}
            className="glass-pill flex cursor-pointer items-center gap-2 px-3.5 py-2 text-sm font-medium"
          >
            <HugeiconsIcon icon={ArrowLeft01Icon} size={15} strokeWidth={2} />
            Back to masterplan
          </button>
        </header>

        {/* The viewer's second renderer draws the apartment model here. */}
        <div id="apartment-popup-canvas" className="relative min-h-0 flex-1">
          <div
            id="apartment-popup-loading"
            className="text-muted-foreground absolute inset-0 z-5 flex items-center justify-center text-sm"
          >
            Loading residence…
          </div>
        </div>

        <footer className="border-border flex flex-col gap-1 border-t px-5 py-4 sm:flex-row sm:items-center sm:justify-between">
          <div className="min-w-0">
            <h2 id="apartment-popup-title" className="font-serif text-xl leading-tight" />
            <p id="apartment-popup-description" className="text-muted-foreground text-sm" />
          </div>
          <div id="apartment-popup-media" className="[&_img]:h-20 [&_img]:rounded-lg" />
          <button
            type="button"
            onClick={() => {
              close()
              useAppStore.getState().setRegisterOpen(true)
            }}
            className="bg-primary text-primary-foreground rounded-control mt-2 shrink-0 cursor-pointer px-4 py-2.5 text-sm font-semibold sm:mt-0"
          >
            Register interest
          </button>
        </footer>
      </div>
    </div>
  )
}
